export default {
      id: "oc-res-month-usage",
      viewBox: "0 0 1053 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-month",
      toString: function () {
        return this.url;
      }
    }